import { getRegisterFunction } from '../../utils/register.js';
import { OneUxInputElement } from './OneUxInputElement.js';
export const register = getRegisterFunction(OneUxInputElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-input': OneUxInputElement;
    "input-3e5c1bb6c3865f7d1093d11bfe578ad6": OneUxInputElement;
  }
}